"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContactCustomerJourneyTypeEnum = void 0;
var ContactCustomerJourneyTypeEnum;
(function (ContactCustomerJourneyTypeEnum) {
    ContactCustomerJourneyTypeEnum["Order"] = "ORDER";
})(ContactCustomerJourneyTypeEnum = exports.ContactCustomerJourneyTypeEnum || (exports.ContactCustomerJourneyTypeEnum = {}));
